import React, { useEffect, useState } from "react";
import { api } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Star, ChatCircleText, CheckCircle, Clock } from "@phosphor-icons/react";
import { toast } from "sonner";

export const MemberTestimonialCard = () => {
  const { t } = useI18n();
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [role, setRole] = useState("");
  const [quote, setQuote] = useState("");
  const [busy, setBusy] = useState(false);
  const [mine, setMine] = useState([]);
  const load = () => api.get("/me/testimonials").then((r) => setMine(r.data.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const submit = async () => {
    if (quote.trim().length < 10) { toast.error(t("testimonial_min")); return; }
    setBusy(true);
    try {
      await api.post("/me/testimonials", { quote: quote.trim(), role: role.trim(), rating });
      toast.success(t("testimonial_thanks"));
      setQuote(""); setRole(""); setRating(5); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-8 bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid="member-testimonial-card">
      <div className="flex items-center gap-2 mb-1"><ChatCircleText size={22} weight="duotone" className="text-emerald-700" /><h2 className="font-display font-bold text-emerald-900 text-xl">{t("member_testimonial_title")}</h2></div>
      <p className="text-sm text-slate-500 mb-4">{t("member_testimonial_sub")}</p>
      <div className="flex items-center gap-1 mb-4" data-testid="rating-stars">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" data-testid={`star-${n}`} onClick={() => setRating(n)} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} className="transition-transform hover:scale-110">
            <Star size={28} weight={(hover || rating) >= n ? "fill" : "regular"} className={(hover || rating) >= n ? "text-amber-400" : "text-slate-300"} />
          </button>
        ))}
      </div>
      <div className="mb-3"><Label className="text-emerald-900 font-semibold text-xs">{t("testimonial_role_optional")}</Label><Input data-testid="member-testimonial-role" className="mt-1 h-10" placeholder="Ej. Socio desde 2020" value={role} onChange={(e) => setRole(e.target.value)} /></div>
      <div className="mb-4"><Label className="text-emerald-900 font-semibold text-xs">{t("your_testimonial")}</Label><Textarea data-testid="member-testimonial-quote" rows={3} className="mt-1" placeholder={t("testimonial_placeholder")} value={quote} onChange={(e) => setQuote(e.target.value)} /></div>
      <Button data-testid="submit-testimonial-btn" onClick={submit} disabled={busy} className="bg-emerald-800 hover:bg-emerald-900">{busy ? "..." : t("submit_testimonial")}</Button>
      {mine.length > 0 && (
        <div className="mt-6 space-y-2" data-testid="my-testimonials">
          {mine.map((m) => (
            <div key={m.id} className="flex items-start gap-2 text-sm rounded-lg bg-slate-50 border border-slate-100 p-3">
              {m.status === "approved" ? <CheckCircle size={18} weight="fill" className="text-emerald-600 mt-0.5 shrink-0" /> : <Clock size={18} weight="fill" className="text-amber-500 mt-0.5 shrink-0" />}
              <div className="flex-1">
                <p className="text-slate-700">“{m.quote}”</p>
                <span className={`text-xs font-semibold ${m.status === "approved" ? "text-emerald-600" : "text-amber-600"}`}>{m.status === "approved" ? t("testimonial_published") : t("testimonial_pending")}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
